import React, { Component } from 'react';
import {toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies';
import {ValidateState} from '../../../functions'; 
import {API_URL} from '../../../constants';
import {updateValueInJson, validateAccesoGeneral, getRoles, esUrl} from '../../../functions';
import axios from 'axios';
import CKEditor from 'ckeditor4-react';
import $ from 'jquery';

export default class AgregarExportaFacil extends Component {

    constructor(props) {

        super(props); 

        this.state = { 
            tituloLongitud:0,
            resource: {
                exfa_Titulo:"",
                exfa_Contenido:"",
                cxfa_Id:"",
                exfa_Orden:this.props.location.state !== undefined ? this.props.location.state.totalRegistros + 1 : "",
                exfa_Activo:true
            },
            Validacion: {
                exfa_Titulo: {
                    Error: false,                    
                },
                exfa_Contenido: {
                    Error: false,                    
                },
                cxfa_Id: {
                    Error: false,                    
                },
                exfa_Orden: {
                    Error: false,                    
                }
            },
            categorias: [],
            hasError:false,    
            hasErrorProceso:false,        
            added: false,
            security: cookie.load('user'),
            roles: [],
            agrupador:"",
            menuGeneral:[]
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onEditorChange = this.onEditorChange.bind(this);

      }
    
    handleClickCancel(e) {

        e.preventDefault();

        const {history: {push}} = this.props;    
        push('/exporta-facil');
     }

     callFunctionButton = (event) => {

        event.preventDefault();

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.exfa_Titulo == '') {              
            newState.Validacion.exfa_Titulo = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.exfa_Contenido == '') {  
            newState.Validacion.exfa_Contenido = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.cxfa_Id == 0) {  
            newState.Validacion.cxfa_Id = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.exfa_Orden == '' || newState.resource.exfa_Orden == 0) {  
            newState.Validacion.exfa_Orden = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ExportaFacilUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'exfa_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                
                let stateResponse = this.state;

                stateResponse.added = true;
                stateResponse.resource.exfa_Titulo = '';
                stateResponse.resource.exfa_Contenido = '';
                stateResponse.resource.cxfa_Id = 0;
                stateResponse.resource.exfa_Orden += 1 ;
                document.getElementById("cxfa_Id").selectedIndex = 0;
                this.setState(stateResponse);

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        toast.error('Error no controlado.');
        this.setState({loading:false});
        });        
    }


    onEditorChange( evt ) {
        let stateResource = this.state.resource;
        stateResource.exfa_Contenido = evt.editor.getData();
        this.setState( {
            resource: stateResource
        } );
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let tituloLongitud = this.state.tituloLongitud;

        let validaciones = this.state.Validacion;
        validaciones[target.name] = {
            Error: false,                    
        }

        if(target.name == 'exfa_Titulo'){
            tituloLongitud = value.length;
        }
        this.setState({
            resource: copyResource,
            tituloLongitud: tituloLongitud,
            Validacion: validaciones
        });  
    }

    componentDidMount()
    {

        if($('#containerPanel').is("*")){
            $('#containerPanel').hide();
        }

        let locationState = this.props.location.state;
        let pathNameList = "/exporta-facil";

        var roles = getRoles(this.state.security);
        var rol = roles.length > 0 ? roles[0].nRolCodigo : "";

        validateAccesoGeneral(locationState, pathNameList, rol); 
        
        const url = `${API_URL}ExportaFacilUX/Recursos`;
        axios.get(url).then(response => response.data)
        .then((data) => {
            if(data.statusCode == 200){
                this.setState({
                    categorias: data.result.categorias,
                    sectores: data.result.sectores,
                    perfiles: data.result.perfiles
                });
            }
        })
        .catch(error => {
            console.log('Error de comunicación');
        });
    }

    render() {
        return (
            <div class="">
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt />
                        <a  href="/">
                            / Panel de Configuración General
                        </a >
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <span> / Agregar Exporta Fácil</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Agregar Exporta Fácil
                </div>

                {
                    this.state.hasErrorProceso ? 
                    <div className="relative">
                        <div className="textAlertaError">
                            <div>Error, no se pudo realizar el registro.</div>
                        </div>
                    </div> : null
                }   

                {
                    this.state.added ? 
                    <div className="relative">
                        <div className="textAlertaOK">
                            <div>Se realizó el registro correctamente.</div>
                        </div>
                    </div>: null
                }             
                
                <div className="div_Modulos_Noticias">
                    <div className="txtFile x-1">
                        <input type="text" placeholder="Título" name='exfa_Titulo' value={this.state.resource.exfa_Titulo} maxLength={25} className={this.state.Validacion.exfa_Titulo.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                        <span data-length={25}>{this.state.tituloLongitud}/25</span>
                    </div>

                    <CKEditor
                    data={this.state.resource.exfa_Contenido}
                    onChange={this.onEditorChange} 
                    />
                   
                    <div className="txtFile x-1">
                        <select name='cxfa_Id' id='cxfa_Id' onChange={this.handleInputChange} className={this.state.Validacion.cxfa_Id.Error ? "error" : ""}>
                            <option value="0">Seleccionar Categoría</option>
                            {
                                this.state.categorias.length > 0 ?
                                this.state.categorias.map((categoria) => (
                                    <option value={categoria.id}>{categoria.nombre.toUpperCase()}</option>
                                ))
                                : null
                            }
                        </select>                        
                    </div>

                    <div className="txtFile x-2">
                        <input type="text" placeholder="Orden" name='exfa_Orden' value={this.state.resource.exfa_Orden} maxLength={2} className={this.state.Validacion.exfa_Orden.Error ? "error" : ""} onChange={this.handleInputChange} onChange={this.handleInputChange}/>
                    </div>

                    <div className="divContenedorBtn_Noticias">
                        <a href="#"  className="btnActivo"  onClick={(event) => this.callFunctionButton(event)}>GUARDAR </a>
                        <a href="#"  onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                <br />
                <br />

            </div>
        )
    }
}